module.exports = __webpack_public_path__ + "img/Nectios_Logo.86f2f0a8.jpg";